<div class="flex-center py-6">
  <div class="narrow-card-container">
    <div class="card">
      <div class="card-body p-4 p-sm-5">
        <div class="row flex-between-center mb-2">
          <div class="col-auto">
            <h5>{{ "general.forgottenPassword" | translate }}</h5>
          </div>
        </div>
        @if (requestSent) {
        <div class="notification my-2">
          <span class="icon bi-info-circle me-2"></span>
          <span class="text my-a">{{
            "forgottenPassword.emailSent" | translate
          }}</span>
        </div>
        <div class="mb-3">
          <button
            class="btn btn-primary d-block w-100 mt-3"
            type="button"
            (click)="cancel()"
          >
            {{ "general.continue" | translate }}
          </button>
        </div>
        } @else {
        <div class="notification my-2">
          <span class="icon bi-info-circle me-2"></span>
          <span class="text my-a">{{
            "forgottenPassword.resetPasswordInfoText" | translate
          }}</span>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <app-validated-input
              label="general.emailAddress"
              inputFormControlName="email"
              [inputFormControl]="$any(form.controls['email'])"
              type="email"
              [validationTrainslations]="{
                required: 'login.emailIsRequired',
                email: 'login.wrongEmailFormat'
              }"
            />
          </div>
          @if (errorMessage) {
          <div class="text-danger small mb-2">{{ errorMessage }}</div>
          }
          <div class="mb-3">
            <button
              class="btn btn-primary d-block w-100 mt-3"
              type="submit"
              [disabled]="loading"
            >
              {{ "general.send" | translate }}
            </button>
          </div>
          <div class="mb-3">
            <button
              class="btn btn-falcon d-block w-100 mt-3"
              type="button"
              (click)="cancel()"
            >
              {{ "general.cancel" | translate }}
            </button>
          </div>
        </form>
        }
      </div>
    </div>
  </div>
</div>
